import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Alert, DialogPlugin, Dropdown, Link, MessagePlugin, Space } from 'tdesign-react';
import { AddCircleIcon, GestureRightIcon } from 'tdesign-icons-react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { fetchClusterDetailByName, fetchGeoList } from '@/slices/clusterSlice';
import SvgIcon from '@/components/SvgIcon';
import { unbindDisasterRecoveryCluster } from '@/services/serviceDiscoveryService';
import PermWrapper from '@/components/PermWrapper';
import OperateTag from './OperateTag';
import BindModal from './BindModal';

const options = [
  // {
  //   content: '修改',
  //   value: 1,
  // },
  { content: '删除', value: 2 },
];

function BindRecoverServer({
  primaryClusterName,
  fetchClusterDetailByName,
  disasterRecoveryClusters,
  isCurrentProvideServiceCluster,
  fetchGeoList,
}) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const navigateToRecoveryCluster = (clusterName) => {
    navigate(`/cluster/dashboard?name=${clusterName}`);
  };

  // 对应的备集群
  const recoveryClusterName = useMemo(() => {
    if (isEmpty(disasterRecoveryClusters)) return null;
    return Object.keys(disasterRecoveryClusters)[0];
  }, [disasterRecoveryClusters]);

  const openBindModal = () => setVisible(true);

  const doRefresh = () => {
    fetchClusterDetailByName(primaryClusterName);
    fetchGeoList(primaryClusterName);
  };

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  const clickHandler = (value) => {
    switch (value) {
      // case 1:
      //   openBindModal();
      //   break;
      case 2:
        {
          const dialog = DialogPlugin.confirm({
            header: '提示',
            theme: 'warning',
            body: '确定解除备集群？',
            confirmBtn: {
              content: '确定',
            },
            onClose: () => dialog.hide(),
            onConfirm: async () => {
              try {
                dialog.update({
                  confirmBtn: { loading: true, content: '确定' },
                });
                await unbindDisasterRecoveryCluster({ primaryClusterName, recoveryClusterName });
                MessagePlugin.success('操作成功！');
                dialog.hide();
                doRefresh();
              } catch (error) {
                console.trace(error);
                throw error;
              } finally {
                dialog.update({
                  confirmBtn: { loading: false, content: '确定' },
                });
              }
            },
          });
        }
        break;
      default:
        break;
    }
  };

  // 已绑定备集群后的操作节点
  const operateNode = (
    <OperateTag
      color='#3361ff'
      operater={
        <PermWrapper resource='pulsar:cluster:recovery'>
          <Dropdown options={options} onClick={({ value }) => clickHandler(value)}>
            <span>
              <Icon type='dots-vertical' size={14} />
            </span>
          </Dropdown>
        </PermWrapper>
      }
      onPopConfirm={() => navigateToRecoveryCluster(recoveryClusterName)}
    >
      备集群：{recoveryClusterName}
    </OperateTag>
  );

  // 备集群提供服务时高亮节点
  const highLightOperateNode = (
    <Alert
      theme='warning'
      style={{ padding: '0 8px', alignItems: 'center', height: '32px' }}
      message={
        <Container>
          <Space size={4} align='center'>
            正在由 <b>备集群</b> 提供服务
            <GestureRightIcon size={14} />
          </Space>
          {operateNode}
        </Container>
      }
    />
  );

  // 已绑定节点综合逻辑
  const hasBindNode = isCurrentProvideServiceCluster ? operateNode : highLightOperateNode;

  // 还未绑定节点
  const unBindNode = (
    <OperateTag
      color='rgb(143, 149, 159)'
      operater={
        <PermWrapper resource='pulsar:cluster:recovery'>
          <ClickLink
            size='small'
            hover='color'
            prefixIcon={<AddCircleIcon />}
            onClick={openBindModal}
          >
            添加
          </ClickLink>
        </PermWrapper>
      }
    >
      <GreyText>暂无备集群</GreyText>
    </OperateTag>
  );

  const node = recoveryClusterName ? hasBindNode : unBindNode;

  return (
    <Root>
      {node}
      <BindModal
        visible={visible}
        primaryClusterName={primaryClusterName}
        handleClose={handleClose}
      />
    </Root>
  );
}

export default connect(null, {
  fetchClusterDetailByName,
  fetchGeoList,
})(BindRecoverServer);

const Root = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`;

const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const GreyText = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  padding-right: 5px;
`;

const ClickLink = styled(Link)`
  color: white !important;
  font-weight: 600 !important;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
`;
